// extracted by mini-css-extract-plugin
export default {"versionSelector":"GameVersionSelector_versionSelector__VoUcR"};